module.exports = {
    getReadWidget:   () => '<ma-boolean-column value="::value"></ma-boolean-column>',
    getLinkWidget:   () => '<a ui-sref="{{detailState}}(detailStateParams)">' + module.exports.getReadWidget() + '</a>',
    getFilterWidget: () => `<ezy-bool-timestamp-field field="::field" value="value" choices="::field.filterChoices()"></ezy-bool-timestamp-field>`,
    getWriteWidget:  () => `<ezy-bool-timestamp-field class="col-sm-6 col-md-6" field="::field" entry="entry" ng-if="true" value="$parent.value"></ezy-bool-timestamp-field>`
};



// WEBPACK FOOTER //
// ./client/app/fieldView/BoolTimestampFieldView.js